import { AiConfigInterface } from '@/components/AiComponent/Interface/AiConfigInterface';
import BubbleListRender, {
  RenderType,
} from '@/pages/ISWAN_CHAT/components/BubbleListRender/BubbleListRender';
import { promptData } from '@/pages/ISWAN_CHAT/components/Chat/Chat.data';
import { useAiMeta } from '@/pages/ISWAN_CHAT/hooks/useAiMeta/useAiMeta';
import { QueryExtra } from '@/pages/ISWAN_CHAT/hooks/useChat/useChat';
import { MessageItem } from '@/pages/ISWAN_CHAT/interface';
import { useModel } from '@@/exports';
import { BulbOutlined, LinkOutlined, WechatWorkOutlined } from '@ant-design/icons';
import { Prompts, Sender, Welcome } from '@ant-design/x';
import { Button, Flex, theme } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import './Chat.fix.css';
import s from './Chat.less';

export interface ChatProps {
  messages?: MessageItem[];
  loading?: boolean;
  onSend?: (message: string, queryExtra: QueryExtra) => void;
  onSetMessages?: (messages: MessageItem[]) => void;
  onStartNext?: () => void;
  onCancel?: () => void;
  renderType?: RenderType;
  aiConfig?: AiConfigInterface;
}

const Chat: React.FC<ChatProps> = (props: ChatProps) => {
  const {
    messages = [],
    loading = true,
    onSend,
    onStartNext,
    onCancel,
    renderType,
    aiConfig,
  } = props;

  const { name, usage } = useAiMeta();
  const [aiType] = useModel('ISWAN_CHAT.aiType');
  const chatListRef = useRef<HTMLDivElement>(null);
  const [sendHeaderOpen, setSendHeaderOpen] = useState(false);
  const [content, setContent] = useState('');
  const [queryExtra, setQueryExtra] = useState<QueryExtra>({});
  const { token } = theme.useToken();

  function scrollBottom() {
    if (!chatListRef.current) return;
    chatListRef.current.scrollTop = chatListRef.current.scrollHeight;
    // element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
    // chatListRef.current.children[chatListRef.current.children.length - 1].scrollIntoView(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      // let res = await getParameters({$ai_type: aiType});
      // console.log(res, '12321312312')
    };
    fetchData();
  }, []);

  useEffect(() => {
    scrollBottom();
  }, [messages]);

  useEffect(() => {
    // Bubble会把flex状态的chatList撑大，这里强行限制高度
    if (!chatListRef.current) return;
    const originHeight = chatListRef.current.clientHeight + 'px';
    chatListRef.current.style.height = originHeight;
    chatListRef.current.style.minHeight = originHeight;
    chatListRef.current.style.maxHeight = originHeight;
  }, []);

  function handleStartNext() {
    if (onStartNext) {
      onStartNext();
    }
  }

  function handleCancel() {
    if (onCancel) {
      onCancel();
    }
  }

  function handleSetDeepSeek() {
    if (queryExtra?.deepseek === '启用') {
      setQueryExtra({ ...queryExtra, deepseek: undefined });
    } else {
      setQueryExtra({ ...queryExtra, deepseek: '启用' });
    }
  }

  function handlePromptClick(e: string) {
    // if (!onSetMessages || !onSend) {
    //   return;
    // }
    // // 如果最后一句是用户的消息，把这句话发出去
    // if (e.messages[e.messages.length - 1].role === 'user') {
    //   onSetMessages(e.messages.slice(0, e.messages.length - 1));
    //   onSend(e.messages[e.messages.length - 1].content);
    // }
    if (onSend) {
      onSend(e, queryExtra);
    }
  }

  const headerNodeRender = () => {
    return (
      <>
        <Sender.Header
          title="智能体选择"
          open={sendHeaderOpen}
          onOpenChange={setSendHeaderOpen}
          styles={{
            header: { backgroundColor: '#DBEAFE' },
            content: { padding: 0 },
          }}
        >
          <div className={s.senderHeaderBody}>
            <Prompts
              title="✨ 你可以这样问我："
              items={[]}
              styles={{
                item: {
                  flex: 'none',
                  width: 'calc(50% - 6px)',
                },
              }}
            />
          </div>
        </Sender.Header>
      </>
    );
  };

  return (
    <>
      <div className={s.main + ' __fix__Chat'}>
        <div className={s.chatList} ref={chatListRef}>
          <Welcome
            icon="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*s5sNRo5LjfQAAAAAAAAAAAAADgCCAQ/fmt.webp"
            title={`欢迎使用 ${name}`}
            description={usage}
            style={{ marginBottom: '20px' }}
          />
          {/*<Welcome*/}
          {/*  icon="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*s5sNRo5LjfQAAAAAAAAAAAAADgCCAQ/fmt.webp"*/}
          {/*  title={`欢迎使用 ${name}`}*/}
          {/*  description={usage}*/}
          {/*  style={{marginBottom: '20px'}}*/}
          {/*/>*/}
          {aiConfig?.bubbleListRender ? (
            <div>
              <div className={`__fix__bubbleListRender`}>{aiConfig.bubbleListRender()}</div>
            </div>
          ) : (
            <BubbleListRender isSuccess={!loading} messages={messages} renderType={renderType} />
          )}
          {aiType !== 'Knowledge' && aiType !== 'Robot' && messages.length === 0 && (
            <>
              <div className={s.promptWrapper}>
                <Prompts
                  title="✨ 你可以这样问我："
                  items={promptData}
                  vertical
                  onItemClick={(e) => handlePromptClick(e.data.description as string)}
                />
              </div>
            </>
          )}
        </div>

        {aiType !== 'Robot' && messages.length > 0 && onStartNext && (
          <div className={s.startNextWrapper} onClick={handleStartNext}>
            <div className={s.startNext}>
              <WechatWorkOutlined />
              <div>开启新对话</div>
            </div>
          </div>
        )}
        <div className={s.senderPl} />
        <div className={s.sender}>
          {aiConfig?.actionRender ? (
            <div className={s.sendAction}>{aiConfig.actionRender()}</div>
          ) : (
            <div className={s.sendAction}>
              {/*<Button*/}
              {/*  icon={<ScheduleOutlined/>}*/}
              {/*  onClick={() =>{}}*/}
              {/*>*/}
              {/*  Upgrades*/}
              {/*</Button>*/}
              {/*<Button*/}
              {/*  icon={<ProductOutlined/>}*/}
              {/*  onClick={() => {}}*/}
              {/*>*/}
              {/*  Components*/}
              {/*</Button>*/}
              {/*<Button icon={<AppstoreAddOutlined/>}>More</Button>*/}
            </div>
          )}

          {aiConfig?.senderRender ? (
            <div>{aiConfig.senderRender()}</div>
          ) : (
            <Sender
              loading={loading}
              value={content}
              autoSize={{ minRows: 2, maxRows: 2 }}
              placeholder={'在这里输入你的问题...'}
              header={headerNodeRender()}
              actions={false}
              footer={({ components }) => {
                const { SendButton, LoadingButton } = components;
                return (
                  <Flex justify="space-between" align="center">
                    <Flex gap="small" align="center">
                      <Button
                        style={{
                          fontSize: 18,
                          color: token.colorText,
                        }}
                        type="text"
                        icon={<LinkOutlined />}
                        onClick={() => {
                          setSendHeaderOpen(!sendHeaderOpen);
                        }}
                      />
                      <Button
                        icon={<BulbOutlined />}
                        onClick={handleSetDeepSeek}
                        type={queryExtra?.deepseek === '启用' ? 'primary' : 'default'}
                      >
                        深度思考
                      </Button>
                    </Flex>
                    <Flex align="center">
                      {loading ? (
                        <LoadingButton type="default" />
                      ) : (
                        <SendButton type="primary" disabled={false} />
                      )}
                    </Flex>
                  </Flex>
                );
              }}
              onChange={setContent}
              onSubmit={(nextContent) => {
                if (onSend) {
                  onSend(nextContent, queryExtra);
                }
                setContent('');
                scrollBottom();
              }}
              onCancel={handleCancel}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Chat;
